import { finalize, takeUntil } from "rxjs/operators";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
} from "@angular/core";
import { AtachmentService } from "src/app/core/services/atachment.service";
import { IAttachmentFile } from "./iAttachmentFile";
import { Subject } from "rxjs";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";

@Component({
  selector: "uploaded-attachments-files",
  templateUrl: "./uploaded-attachments-files.component.html",
  styleUrls: ["./uploaded-attachments-files.component.scss"],
})
export class UploadedAttachmentsFilesComponent implements OnInit, OnDestroy {
  translationModulesEnum = TranslationModuleEnum;

  @Input() files: any = [];
  @Input() maxSize?: number;
  @Input() supportedTypes?: string;
  @Input() showHint?: boolean = true;
  @Input() canDeleted?: boolean = true;
  @Input() old?: boolean = false;
  @Input() isRequired?: boolean = false;
  @Input() TranslationKey: string;
  @Input() TranslationModuleEnum: number;

  @Input() mode = "";
  @Output() deleteFile = new EventEmitter();

  deletingFileIndex: number;
  downloadingFileIndex: number;
  private endSub$ = new Subject();

  constructor(private attachmentService: AtachmentService) {}

  ngOnInit(): void {}

  onDeleteFile(fileIndex: number) {
    this.deleteFile.emit(fileIndex);
  }

  onViewLocalFile(uploadedFile: IAttachmentFile, index: number) {
    this.downloadingFileIndex = index;
    let fileName = "";

    // preview new file
    if (!!uploadedFile.size) {
      fileName = uploadedFile.name;
      const downloadFile = file => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          this.openInNewTab(e.target.result.toString(),fileName);
          this.downloadingFileIndex = null;
        };
      };
      downloadFile(uploadedFile.file);

      // preview old file
    } else {
      fileName = uploadedFile.fileName;
      this.attachmentService
        .getAttachmentURLs(fileName)
        .pipe(
          takeUntil(this.endSub$),
          finalize(() => {
            this.files[index].isLoading = false;
            this.downloadingFileIndex = null;
          })
        )
        .subscribe(r => {
          let fileUrl = r[0].fileUrl;
          this.openInNewTab(fileUrl, fileName);
        });
    }
  }

  openInNewTab = (url: string, fileName:string) => {
    const link = document.createElement("a");
    link.target = "_blank";
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  ngOnDestroy(): void {
    this.endSub$.next(null);
    this.endSub$.complete();
  }
}
